import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { images, externalLinks } from '../data/mock';
import { ExternalLink } from 'lucide-react';

const RooftopEmotion = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-[#121212] py-16 md:py-24 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Image */}
          <div className="relative overflow-hidden" style={{ aspectRatio: '4/3' }}>
            <img 
              src={images.firepit2} 
              alt="Rooftop Firepit"
              className="w-full h-full object-cover"
            />
            {/* Glow effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#00FFD1]/10 to-transparent" />
          </div>
          
          {/* Content */}
          <div className="lg:pl-8">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
              {t('rooftopTitle')}
            </h2>
            <p className="text-white/80 text-lg whitespace-pre-line leading-relaxed mb-8">
              {t('rooftopDesc')}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={externalLinks.naverStore}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#00FFD1] text-black font-semibold transition-all duration-300 hover:bg-[#00FFD1]/10 hover:text-[#00FFD1]"
                style={{ borderRadius: 0 }}
              >
                {t('reserve')}
                <ExternalLink size={16} />
              </a>
              <a
                href={externalLinks.kakao}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white/10 text-white font-semibold transition-all duration-300 hover:bg-white hover:text-black"
                style={{ borderRadius: 0 }}
              >
                {t('inquiry')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RooftopEmotion;